module.exports = "pegasus/assets/theme4/img1x.png";